"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = void 0;

var _stylitas = require("@creditas/stylitas");

var _styledTools = require("styled-tools");

var Layout = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

exports.Layout = Layout;
Layout.Flex = _stylitas.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  margin: 0;\n  padding: ", ";\n  flex: ", ";\n  text-decoration: none;\n  border: none;\n  background-color: transparent;\n"])), (0, _styledTools.prop)('direction', 'row'), (0, _styledTools.prop)('alignItems'), (0, _styledTools.prop)('justifyContent', 'space-between'), (0, _styledTools.prop)('padding', '16px 20px'), (0, _styledTools.prop)('flex'));
Layout.Box = _stylitas.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: ", ";\n  margin: ", ";\n"])), (0, _styledTools.prop)('padding'), (0, _styledTools.prop)('margin'));
Layout.Divider = _stylitas.styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background: ", ";\n  height: 1px;\n  width: 100%;\n  margin: 3px 0;\n"])), (0, _styledTools.theme)('colorBackgroundNeutral10'));